import { render, staticRenderFns } from "./AddVideo.vue?vue&type=template&id=4e3cb6fe&scoped=true&"
import script from "./AddVideo.vue?vue&type=script&lang=js&"
export * from "./AddVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3cb6fe",
  null
  
)

export default component.exports